import React from "react";

export default function Warning({
  fill = "#F09F00",
  width = "180",
  height = "180",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 180 180'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M90 0C40.2991 0 0 40.2991 0 90C0 139.701 40.2991 180 90 180C139.701 180 180 139.701 180 90C180 40.2991 139.701 0 90 0ZM90 164.732C48.7366 164.732 15.2679 131.263 15.2679 90C15.2679 48.7366 48.7366 15.2679 90 15.2679C131.263 15.2679 164.732 48.7366 164.732 90C164.732 131.263 131.263 164.732 90 164.732Z'
        fill={fill}
      />
      <path
        d='M80.3572 125.357C80.3572 127.915 81.3732 130.367 83.1816 132.176C84.99 133.984 87.4427 135 90.0001 135C92.5575 135 95.0102 133.984 96.8186 132.176C98.627 130.367 99.643 127.915 99.643 125.357C99.643 122.8 98.627 120.347 96.8186 118.539C95.0102 116.73 92.5575 115.714 90.0001 115.714C87.4427 115.714 84.99 116.73 83.1816 118.539C81.3732 120.347 80.3572 122.8 80.3572 125.357ZM85.1787 102.857H94.8215C95.7055 102.857 96.4287 102.134 96.4287 101.25V46.6071C96.4287 45.7232 95.7055 45 94.8215 45H85.1787C84.2947 45 83.5715 45.7232 83.5715 46.6071V101.25C83.5715 102.134 84.2947 102.857 85.1787 102.857Z'
        fill={fill}
      />
    </svg>
  );
}
